import { tPresetsLib } from '@/Interfaces/presets';
import { tc_1995_004030 } from '@/Constants/templateConfigs/tc_1995/004030';
import { tc_1995_120604 } from '@/Constants/templateConfigs/tc_1995/120604';
import { tc_1995_2_102400 } from '@/Constants/templateConfigs/tc_1995_2/102400';

export const presetsLib: tPresetsLib = [
    tc_1995_120604,
    tc_1995_2_102400,
    tc_1995_004030,
];
